export default "__VITE_ASSET__DfLMTl60__"